import { render, staticRenderFns } from "./impactGoalList.vue?vue&type=template&id=7997751f&scoped=true"
import script from "./impactGoalList.vue?vue&type=script&lang=ts&setup=true"
export * from "./impactGoalList.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./impactGoalList.vue?vue&type=style&index=0&id=7997751f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7997751f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxToolbarSection: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/toolbarSection.vue').default,CompanyLogo: require('/home/runner/work/assessment-service/assessment-service/frontend/components/company/CompanyLogo.vue').default,ImpactGoalProgressSection: require('/home/runner/work/assessment-service/assessment-service/frontend/components/impact-goal/ProgressSection.vue').default,ImpactPill: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ImpactPill.vue').default,SdgList: require('/home/runner/work/assessment-service/assessment-service/frontend/components/SdgList.vue').default,IxButtonWhite: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/button/White.vue').default,ExportsImpactGoalExport: require('/home/runner/work/assessment-service/assessment-service/frontend/components/exports/ImpactGoalExport.vue').default,IxDialogImpactLock: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/dialog/ImpactLock.vue').default})
